export default {
      id: "ic-nav-play-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-play-usage",
      toString: function () {
        return this.url;
      }
    }